module.exports = __webpack_public_path__ + "static/DevProcessTransparent-3adb87079d92f10dae3069a46e3c6b5f.png";